var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 695.66 233.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;stroke-width:0px;}.cls-2{fill-rule:evenodd;}.cls-3{stroke:#fff;stroke-miterlimit:22.93;stroke-width:.23px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.11,
    y: 0.11,
    width: 695.43,
    height: 233.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.91,
    y: 162.73,
    width: 645.8,
    height: 20.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.91,
    y: 189.26,
    width: 645.8,
    height: 20.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m130.88,24.68l-5.25,23.83h-21.66c-13.5,0-38.15,14.42-38.15,40.28,0,20.36,15.42,40.83,40.62,40.69-.06-.03,5.25-.15,6.6-.75.09-.04-5.23,22.94-5.25,23.1-.05.35-6.41.58-6.41.58-39.17,0-65.72-30.5-65.72-63.34,0-35.53,26.56-64.18,66.73-64.18,24.74,0,28.5-.2,28.5-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m428.95,59.82l-21.57,92.58s-26.1.01-31.58-.06c-21.59-.3-46.28-17.02-46.28-46.52,0-24.34,18.96-45.72,46.17-45.72,19.2,0,53.27-.28,53.27-.28h0Zm-73.74,45.95c0,25.42,28.32,28.16,32.44,27.55l12.66-54.42s-17.1.28-20.88.28c-4.82,0-24.22,5.9-24.22,26.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m216.61,59.82l-21.57,92.58s-26.12.01-31.58-.06c-21.61-.3-46.29-17.02-46.29-46.52,0-24.34,18.96-45.72,46.17-45.72,19.19,0,53.26-.28,53.26-.28h0Zm-73.73,45.95c0,25.42,28.3,28.16,32.44,27.55l12.64-54.42s-17.09.28-20.84.28c-4.85,0-24.24,5.9-24.24,26.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m229.68,60.02h24.47l-2.16,9.31s18.23-11.47,25.69-11.34l-4.87,20.89c-11.48,0-26.59,15.42-26.59,15.42l-13.52,58.1h-24.54l21.52-92.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m614.04,60.02h24.47l-2.15,9.31s18.24-11.47,25.69-11.34l-4.87,20.89c-11.46,0-26.57,15.42-26.57,15.42l-13.52,58.1h-24.54l21.49-92.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m283.44,59.82h6.85l4.72-20.23,28.81-7.93-6.56,28.16h17.78l-4.31,19.18h-17.78s-7.54,31.09-9.01,37.98c-1.46,6.9-2.64,16.27,14.61,15.89l-4.61,19.47s-23.04.38-29.06-.2c-6.02-.59-12.05-3.96-9.61-21.27.9-6.37,3.4-15.56,5.38-24.07,2.31-9.98,5.65-24.34,6.25-27.79h-8.13l4.68-19.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m530.6,60.15l26.26-.14s-29.7,42.47-29.62,57.62c.06,15.14,10.89,15.97,17.96,15.97s15.22-.72,15.22-.72l17.24-72.85h24.77l-21.55,92.27s-47.54,0-61.6,0-24.49-12.22-20.14-30.67c4.15-17.59,15.79-39.03,31.46-61.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m422.79,130l-5.03,22.49s27.95-.19,34.54-.19c18.18,0,42.53-19.13,42.53-44.73,0-18.44-9.83-30.81-13.62-36.37-3.17-4.62-8.48-10.69-8.48-18.36s5.99-15.73,17.01-23.11l-23.01-6.78s-20.86,12.67-20.86,32.2c0,22.81,21.44,30.17,21.44,54,0,15.47-11.88,20.6-18.58,20.6-4.67,0-25.93.25-25.93.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs);
export default __webpack_public_path__ + "static/media/CS.edc6c8fdfedc461367fce4b519a630d0.svg";
export { ForwardRef as ReactComponent };